import React from 'react';
import { __ } from '../../translations';
import { Text, CheckList, FontIcon } from '@intigral/shared';
import { Modal } from '@intigral/ui';

const LanguagePopup = ({ selectedLanguage, showPopup = false, onSelect, onClose }) => {
    const icon = <FontIcon name="check-green" md="smaller" color="green" />;

    const options = [
        // {
        //     text: <div style={{ cursor: 'pointer', display:'none', width: '100%' }}>{__('manage_profile_off')}</div>,
        //     onClick: () => {
        //         onSelect('off');
        //         onClose();
        //     },
        //     value: selectedLanguage === 'off' ? icon : '',
        // },
        {
            text: <div style={{ cursor: 'pointer', width: '100%' }}>{__('manage_profile_Arabic')}</div>,
            onClick: () => {
                onSelect('ar');
                onClose();
            },
            value: selectedLanguage === 'ar' ? icon : '',
        },
        {
            text: <div style={{ cursor: 'pointer', width: '100%' }}>{__('manage_profile_English')}</div>,
            onClick: () => {
                onSelect('en');
                onClose();
            },
            value: selectedLanguage === 'en' ? icon : '',
        },
    ];

    return (
        <>
            <Modal widthSet="small" {...(showPopup ? { open: true } : {})} onOpenChange={(e) => onClose()}>
                <Text as="h4" variant="h3" margin="3x" alignment="start">
                    {__('manage_profile_select_your_language')}
                </Text>
                <CheckList items={options} border noIcon />
            </Modal>
        </>
    );
};

export default LanguagePopup;
